var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#7074D5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "auto"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99023 12V3.46875H7.39844C8.14062 3.46875 8.79688 3.63281 9.36719 3.96094C9.9375 4.28906 10.377 4.75586 10.6855 5.36133C10.998 5.9668 11.1562 6.66211 11.1602 7.44727V7.99219C11.1602 8.79688 11.0039 9.50195 10.6914 10.1074C10.3828 10.7129 9.93945 11.1777 9.36133 11.502C8.78711 11.8262 8.11719 11.9922 7.35156 12H4.99023ZM6.11523 4.39453V11.0801H7.29883C8.16602 11.0801 8.83984 10.8105 9.32031 10.2715C9.80469 9.73242 10.0469 8.96484 10.0469 7.96875V7.4707C10.0469 6.50195 9.81836 5.75 9.36133 5.21484C8.9082 4.67578 8.26367 4.40234 7.42773 4.39453H6.11523Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDTag);
export default __webpack_public_path__ + "static/media/d-tag.4930ae1e5bf3a3c933c4881c3963eae9.svg";
export { ForwardRef as ReactComponent };